import { ForwardedRef, forwardRef } from "react";
import Figure, { FigurePosition } from "../../Figure/Figure";
import TextSplit from "../../TextSplit/TextSplit";
import './OurCommitmentSlide.css';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

const OurCommitmentSlide = forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => {
  return (
    <Box className="content-slide" id="our-commitment" ref={ref}>
      <Grid container gap={4} flexDirection="column" className="our-commitment-content-container">
        <Grid item className="our-commitment-item" id="our-promise">
          <Box className="our-commitment-item-body"
            sx={{
              px: {
                xs: 2,   // padding-left/right: 16px
                sm: 4,   // 32px
                md: 6,   // 48px
                lg: 10,  // 80px (matches your current CSS)
              },
            }}
          >
            <TextSplit className="our-commitment-title h1" id="our-promise-title"
              sx={{
                fontSize: {
                  xs: '24px',
                  sm: '28px',
                  md: '32px',
                  lg: '36px',
                },
              }}
            >
              Our Promise
            </TextSplit>
            <TextSplit className="our-commitment-content" id="our-promise-content"
              sx={{
                fontSize: {
                  xs: '16px',
                  sm: '18px',
                  md: '21px',
                  lg: '24px',
                },
              }}
            >
              Our Commitment to strict quality assurance standards and meticulous documentation enables us to consistently produce results that exceed customer expectations on budget and on time.
            </TextSplit>
          </Box>
          <Box className="figure-wrapper">
            <Figure position={FigurePosition.RIGHT} src="/img/our-promise.jpg" alt={""} id={"our-promise-figure"} label={""}></Figure>
          </Box>
        </Grid>
        <Grid item className="our-commitment-item" id={"our-approach"}>
          <Box className="our-commitment-item-body"
            sx={{
              px: {
                xs: 2,   // padding-left/right: 16px
                sm: 4,   // 32px
                md: 6,   // 48px
                lg: 10,  // 80px (matches your current CSS)
              },
            }}
          >
            <TextSplit className="our-commitment-title" id="our-approach-title"
              sx={{
                fontSize: {
                  xs: '24px',
                  sm: '28px',
                  md: '32px',
                  lg: '36px',
                },
              }}
            >
              Our Approach
            </TextSplit>
            <TextSplit className="our-commitment-content" id="our-approach-content"
              sx={{
                fontSize: {
                  xs: '16px',
                  sm: '18px',
                  md: '21px',
                  lg: '24px',
                },
              }}
            >
              Our People, Technology, processes, and leading edge equipment ensure we deliver successful solutions to our clients across a host of high-tech industries. By making use of a unique combination of tools we are able to tackle any small and complex machined components ina  host of challenging materials.
            </TextSplit>
          </Box>
          <Box className="figure-wrapper">
            <Figure position={FigurePosition.LEFT} src="/img/our-approach.jpg" alt={""} id={"our-approach-figure"} label={""}></Figure>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
});

export default OurCommitmentSlide;